import React from 'react';
import MeetingType, {MEETING_TYPES} from 'records/MeetingType';
import RadioField from 'components/pure/utils/form/RadioField';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import InputField from 'components/pure/utils/form/InputField';
import isNil from 'lodash/isNil';

const typeLabels = {
  PhysicalLocation: {
    label: 'In Person',
    locationLabel: 'Location',
    placeholder: 'Blue Room',
  },
  Phone: {
    label: 'By Phone Conference',
    locationLabel: 'Number',
    placeholder: '+1 (123) 456-7890',
  },
  Other: {
    label: 'Other (e.g. online conference)',
    locationLabel: 'Location',
    placeholder: 'www.conference.com - Code: #1234',
  },
};

export default class MeetingTypeSelector extends React.PureComponent {
  /**
   * Updates the type and appropriate detail field of the meetingType.
   * Detail is set to an empty string to ensure that at least one of the
   * detail fields are non-null so the type can be properly inferred during
   * deserialization from the API.
   */
  changeMeetingType(type, detail = '') {
    const {onChange} = this.props;

    const update = type === null ? null : new MeetingType({meetingType: type}).setDetail(detail);

    onChange(update);
  }

  locationLabel(type) {
    const {showLocationLabels} = this.props;
    return showLocationLabels ? typeLabels[type].locationLabel : '';
  }

  render() {
    const {meetingType, showErrors, errors, disabled} = this.props;
    const defaultMeetingType = isNil(meetingType) ? null : new MeetingType(meetingType);

    return (
      <div className="meeting-location-type">
        {Object.values(MEETING_TYPES).map(type => (
          <div key={type}>
            <RadioField
              label={typeLabels[type].label}
              disabled={disabled}
              checked={!!defaultMeetingType && defaultMeetingType.meetingType === type}
              onClick={() => this.changeMeetingType(type)}
            />
            {defaultMeetingType && defaultMeetingType.meetingType === type && (
              <FieldContainer
                error={showErrors ? errors[type] : null}
                label={this.locationLabel(type)}>
                <InputField
                  disabled={disabled}
                  value={defaultMeetingType.detail(type) || ''}
                  placeholder={typeLabels[type].placeholder}
                  onChange={value => this.changeMeetingType(type, value)}
                />
              </FieldContainer>
            )}
          </div>
        ))}
        <RadioField
          disabled={disabled}
          label={`No meetings required - we’ll just review at the plan’s schedule using Coach`}
          checked={!defaultMeetingType || defaultMeetingType.detail() === null}
          onClick={() => this.changeMeetingType(null)}
        />
      </div>
    );
  }
}
